// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/delegation_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { DelegationTask } from "./delegations_pb.ts";
import { UploadAttachment } from "./common_pb.ts";
import { Family } from "./advisors_service_pb.ts";

/**
 * @generated from message protogen.CreateDelegationTaskRequest
 */
export class CreateDelegationTaskRequest extends Message<CreateDelegationTaskRequest> {
  /**
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: string detailsJson = 3;
   */
  detailsJson = "";

  /**
   * @generated from field: string agentThreadRef = 4;
   */
  agentThreadRef = "";

  /**
   * @generated from field: string taskRef = 5;
   */
  taskRef = "";

  /**
   * @generated from field: string functionCallId = 6;
   */
  functionCallId = "";

  /**
   * @generated from field: string serviceType = 7;
   */
  serviceType = "";

  /**
   * @generated from field: int64 actionDateSec = 8;
   */
  actionDateSec = protoInt64.zero;

  /**
   * @generated from field: int32 timeEstimateMinutes = 9;
   */
  timeEstimateMinutes = 0;

  constructor(data?: PartialMessage<CreateDelegationTaskRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateDelegationTaskRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "detailsJson", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "agentThreadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "taskRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "functionCallId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "serviceType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "actionDateSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "timeEstimateMinutes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateDelegationTaskRequest {
    return new CreateDelegationTaskRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateDelegationTaskRequest {
    return new CreateDelegationTaskRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateDelegationTaskRequest {
    return new CreateDelegationTaskRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateDelegationTaskRequest | PlainMessage<CreateDelegationTaskRequest> | undefined, b: CreateDelegationTaskRequest | PlainMessage<CreateDelegationTaskRequest> | undefined): boolean {
    return proto3.util.equals(CreateDelegationTaskRequest, a, b);
  }
}

/**
 * @generated from message protogen.CreateDelegationTaskResponse
 */
export class CreateDelegationTaskResponse extends Message<CreateDelegationTaskResponse> {
  /**
   * @generated from field: protogen.DelegationTask delegationTask = 1;
   */
  delegationTask?: DelegationTask;

  constructor(data?: PartialMessage<CreateDelegationTaskResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateDelegationTaskResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "delegationTask", kind: "message", T: DelegationTask },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateDelegationTaskResponse {
    return new CreateDelegationTaskResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateDelegationTaskResponse {
    return new CreateDelegationTaskResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateDelegationTaskResponse {
    return new CreateDelegationTaskResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateDelegationTaskResponse | PlainMessage<CreateDelegationTaskResponse> | undefined, b: CreateDelegationTaskResponse | PlainMessage<CreateDelegationTaskResponse> | undefined): boolean {
    return proto3.util.equals(CreateDelegationTaskResponse, a, b);
  }
}

/**
 * @generated from message protogen.AdminCreateDelegationTaskRequest
 */
export class AdminCreateDelegationTaskRequest extends Message<AdminCreateDelegationTaskRequest> {
  /**
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: string detailsJson = 3;
   */
  detailsJson = "";

  /**
   * @generated from field: string serviceType = 4;
   */
  serviceType = "";

  /**
   * @generated from field: int64 actionDateSec = 5;
   */
  actionDateSec = protoInt64.zero;

  /**
   * @generated from field: int32 timeEstimateMinutes = 6;
   */
  timeEstimateMinutes = 0;

  /**
   * optional; falls back to the internal system family when blank
   *
   * @generated from field: string familyRef = 7;
   */
  familyRef = "";

  constructor(data?: PartialMessage<AdminCreateDelegationTaskRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminCreateDelegationTaskRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "detailsJson", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "serviceType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "actionDateSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "timeEstimateMinutes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminCreateDelegationTaskRequest {
    return new AdminCreateDelegationTaskRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminCreateDelegationTaskRequest {
    return new AdminCreateDelegationTaskRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminCreateDelegationTaskRequest {
    return new AdminCreateDelegationTaskRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AdminCreateDelegationTaskRequest | PlainMessage<AdminCreateDelegationTaskRequest> | undefined, b: AdminCreateDelegationTaskRequest | PlainMessage<AdminCreateDelegationTaskRequest> | undefined): boolean {
    return proto3.util.equals(AdminCreateDelegationTaskRequest, a, b);
  }
}

/**
 * @generated from message protogen.AdminCreateDelegationTaskResponse
 */
export class AdminCreateDelegationTaskResponse extends Message<AdminCreateDelegationTaskResponse> {
  /**
   * @generated from field: protogen.DelegationTask delegationTask = 1;
   */
  delegationTask?: DelegationTask;

  constructor(data?: PartialMessage<AdminCreateDelegationTaskResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminCreateDelegationTaskResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "delegationTask", kind: "message", T: DelegationTask },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminCreateDelegationTaskResponse {
    return new AdminCreateDelegationTaskResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminCreateDelegationTaskResponse {
    return new AdminCreateDelegationTaskResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminCreateDelegationTaskResponse {
    return new AdminCreateDelegationTaskResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AdminCreateDelegationTaskResponse | PlainMessage<AdminCreateDelegationTaskResponse> | undefined, b: AdminCreateDelegationTaskResponse | PlainMessage<AdminCreateDelegationTaskResponse> | undefined): boolean {
    return proto3.util.equals(AdminCreateDelegationTaskResponse, a, b);
  }
}

/**
 * @generated from message protogen.AdminListDelegationTasksRequest
 */
export class AdminListDelegationTasksRequest extends Message<AdminListDelegationTasksRequest> {
  /**
   * @generated from field: repeated string statuses = 1;
   */
  statuses: string[] = [];

  constructor(data?: PartialMessage<AdminListDelegationTasksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminListDelegationTasksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "statuses", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminListDelegationTasksRequest {
    return new AdminListDelegationTasksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminListDelegationTasksRequest {
    return new AdminListDelegationTasksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminListDelegationTasksRequest {
    return new AdminListDelegationTasksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AdminListDelegationTasksRequest | PlainMessage<AdminListDelegationTasksRequest> | undefined, b: AdminListDelegationTasksRequest | PlainMessage<AdminListDelegationTasksRequest> | undefined): boolean {
    return proto3.util.equals(AdminListDelegationTasksRequest, a, b);
  }
}

/**
 * @generated from message protogen.AdminListDelegationTasksResponse
 */
export class AdminListDelegationTasksResponse extends Message<AdminListDelegationTasksResponse> {
  /**
   * @generated from field: repeated protogen.DelegationTask delegationTasks = 1;
   */
  delegationTasks: DelegationTask[] = [];

  constructor(data?: PartialMessage<AdminListDelegationTasksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminListDelegationTasksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "delegationTasks", kind: "message", T: DelegationTask, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminListDelegationTasksResponse {
    return new AdminListDelegationTasksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminListDelegationTasksResponse {
    return new AdminListDelegationTasksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminListDelegationTasksResponse {
    return new AdminListDelegationTasksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AdminListDelegationTasksResponse | PlainMessage<AdminListDelegationTasksResponse> | undefined, b: AdminListDelegationTasksResponse | PlainMessage<AdminListDelegationTasksResponse> | undefined): boolean {
    return proto3.util.equals(AdminListDelegationTasksResponse, a, b);
  }
}

/**
 * @generated from message protogen.AdminUpdateDelegationTaskRequest
 */
export class AdminUpdateDelegationTaskRequest extends Message<AdminUpdateDelegationTaskRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string status = 2;
   */
  status = "";

  /**
   * @generated from field: int32 timeSpentMinutes = 3;
   */
  timeSpentMinutes = 0;

  /**
   * @generated from field: string commentContent = 4;
   */
  commentContent = "";

  /**
   * @generated from field: repeated protogen.UploadAttachment attachments = 5;
   */
  attachments: UploadAttachment[] = [];

  /**
   * @generated from field: string recipientType = 6;
   */
  recipientType = "";

  /**
   * @generated from field: string commentContentHtml = 7;
   */
  commentContentHtml = "";

  constructor(data?: PartialMessage<AdminUpdateDelegationTaskRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminUpdateDelegationTaskRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timeSpentMinutes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "commentContent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "attachments", kind: "message", T: UploadAttachment, repeated: true },
    { no: 6, name: "recipientType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "commentContentHtml", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminUpdateDelegationTaskRequest {
    return new AdminUpdateDelegationTaskRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminUpdateDelegationTaskRequest {
    return new AdminUpdateDelegationTaskRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminUpdateDelegationTaskRequest {
    return new AdminUpdateDelegationTaskRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AdminUpdateDelegationTaskRequest | PlainMessage<AdminUpdateDelegationTaskRequest> | undefined, b: AdminUpdateDelegationTaskRequest | PlainMessage<AdminUpdateDelegationTaskRequest> | undefined): boolean {
    return proto3.util.equals(AdminUpdateDelegationTaskRequest, a, b);
  }
}

/**
 * @generated from message protogen.AdminUpdateDelegationTaskResponse
 */
export class AdminUpdateDelegationTaskResponse extends Message<AdminUpdateDelegationTaskResponse> {
  /**
   * @generated from field: protogen.DelegationTask delegationTask = 1;
   */
  delegationTask?: DelegationTask;

  constructor(data?: PartialMessage<AdminUpdateDelegationTaskResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminUpdateDelegationTaskResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "delegationTask", kind: "message", T: DelegationTask },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminUpdateDelegationTaskResponse {
    return new AdminUpdateDelegationTaskResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminUpdateDelegationTaskResponse {
    return new AdminUpdateDelegationTaskResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminUpdateDelegationTaskResponse {
    return new AdminUpdateDelegationTaskResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AdminUpdateDelegationTaskResponse | PlainMessage<AdminUpdateDelegationTaskResponse> | undefined, b: AdminUpdateDelegationTaskResponse | PlainMessage<AdminUpdateDelegationTaskResponse> | undefined): boolean {
    return proto3.util.equals(AdminUpdateDelegationTaskResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListDelegationTasksRequest
 */
export class ListDelegationTasksRequest extends Message<ListDelegationTasksRequest> {
  /**
   * @generated from field: repeated string statuses = 1;
   */
  statuses: string[] = [];

  /**
   * @generated from field: bool assigned = 2;
   */
  assigned = false;

  constructor(data?: PartialMessage<ListDelegationTasksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListDelegationTasksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "statuses", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "assigned", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDelegationTasksRequest {
    return new ListDelegationTasksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDelegationTasksRequest {
    return new ListDelegationTasksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDelegationTasksRequest {
    return new ListDelegationTasksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDelegationTasksRequest | PlainMessage<ListDelegationTasksRequest> | undefined, b: ListDelegationTasksRequest | PlainMessage<ListDelegationTasksRequest> | undefined): boolean {
    return proto3.util.equals(ListDelegationTasksRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListDelegationTasksResponse
 */
export class ListDelegationTasksResponse extends Message<ListDelegationTasksResponse> {
  /**
   * @generated from field: repeated protogen.DelegationTask delegationTasks = 1;
   */
  delegationTasks: DelegationTask[] = [];

  constructor(data?: PartialMessage<ListDelegationTasksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListDelegationTasksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "delegationTasks", kind: "message", T: DelegationTask, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDelegationTasksResponse {
    return new ListDelegationTasksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDelegationTasksResponse {
    return new ListDelegationTasksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDelegationTasksResponse {
    return new ListDelegationTasksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDelegationTasksResponse | PlainMessage<ListDelegationTasksResponse> | undefined, b: ListDelegationTasksResponse | PlainMessage<ListDelegationTasksResponse> | undefined): boolean {
    return proto3.util.equals(ListDelegationTasksResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateDelegationTaskRequest
 */
export class UpdateDelegationTaskRequest extends Message<UpdateDelegationTaskRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: bool claim = 2;
   */
  claim = false;

  /**
   * @generated from field: string status = 3;
   */
  status = "";

  /**
   * @generated from field: string commentContent = 4;
   */
  commentContent = "";

  /**
   * @generated from field: int32 timeSpentMinutes = 5;
   */
  timeSpentMinutes = 0;

  /**
   * @generated from field: bool unassign = 6;
   */
  unassign = false;

  /**
   * @generated from field: repeated protogen.UploadAttachment attachments = 7;
   */
  attachments: UploadAttachment[] = [];

  /**
   * @generated from field: string timeEntriesJson = 8;
   */
  timeEntriesJson = "";

  /**
   * @generated from field: optional int64 actionDateSec = 9;
   */
  actionDateSec?: bigint;

  /**
   * @generated from field: string recipientType = 10;
   */
  recipientType = "";

  /**
   * @generated from field: string commentContentHtml = 11;
   */
  commentContentHtml = "";

  constructor(data?: PartialMessage<UpdateDelegationTaskRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateDelegationTaskRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "claim", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "commentContent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "timeSpentMinutes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "unassign", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "attachments", kind: "message", T: UploadAttachment, repeated: true },
    { no: 8, name: "timeEntriesJson", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "actionDateSec", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "recipientType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "commentContentHtml", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateDelegationTaskRequest {
    return new UpdateDelegationTaskRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateDelegationTaskRequest {
    return new UpdateDelegationTaskRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateDelegationTaskRequest {
    return new UpdateDelegationTaskRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateDelegationTaskRequest | PlainMessage<UpdateDelegationTaskRequest> | undefined, b: UpdateDelegationTaskRequest | PlainMessage<UpdateDelegationTaskRequest> | undefined): boolean {
    return proto3.util.equals(UpdateDelegationTaskRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateDelegationTaskResponse
 */
export class UpdateDelegationTaskResponse extends Message<UpdateDelegationTaskResponse> {
  /**
   * @generated from field: protogen.DelegationTask delegationTask = 1;
   */
  delegationTask?: DelegationTask;

  constructor(data?: PartialMessage<UpdateDelegationTaskResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateDelegationTaskResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "delegationTask", kind: "message", T: DelegationTask },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateDelegationTaskResponse {
    return new UpdateDelegationTaskResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateDelegationTaskResponse {
    return new UpdateDelegationTaskResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateDelegationTaskResponse {
    return new UpdateDelegationTaskResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateDelegationTaskResponse | PlainMessage<UpdateDelegationTaskResponse> | undefined, b: UpdateDelegationTaskResponse | PlainMessage<UpdateDelegationTaskResponse> | undefined): boolean {
    return proto3.util.equals(UpdateDelegationTaskResponse, a, b);
  }
}

/**
 * @generated from message protogen.ApplyDelegationTaskDetailsUpdateRequest
 */
export class ApplyDelegationTaskDetailsUpdateRequest extends Message<ApplyDelegationTaskDetailsUpdateRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: string detailsJson = 3;
   */
  detailsJson = "";

  constructor(data?: PartialMessage<ApplyDelegationTaskDetailsUpdateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ApplyDelegationTaskDetailsUpdateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "detailsJson", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ApplyDelegationTaskDetailsUpdateRequest {
    return new ApplyDelegationTaskDetailsUpdateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ApplyDelegationTaskDetailsUpdateRequest {
    return new ApplyDelegationTaskDetailsUpdateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ApplyDelegationTaskDetailsUpdateRequest {
    return new ApplyDelegationTaskDetailsUpdateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ApplyDelegationTaskDetailsUpdateRequest | PlainMessage<ApplyDelegationTaskDetailsUpdateRequest> | undefined, b: ApplyDelegationTaskDetailsUpdateRequest | PlainMessage<ApplyDelegationTaskDetailsUpdateRequest> | undefined): boolean {
    return proto3.util.equals(ApplyDelegationTaskDetailsUpdateRequest, a, b);
  }
}

/**
 * @generated from message protogen.ApplyDelegationTaskDetailsUpdateResponse
 */
export class ApplyDelegationTaskDetailsUpdateResponse extends Message<ApplyDelegationTaskDetailsUpdateResponse> {
  /**
   * @generated from field: protogen.DelegationTask delegationTask = 1;
   */
  delegationTask?: DelegationTask;

  constructor(data?: PartialMessage<ApplyDelegationTaskDetailsUpdateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ApplyDelegationTaskDetailsUpdateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "delegationTask", kind: "message", T: DelegationTask },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ApplyDelegationTaskDetailsUpdateResponse {
    return new ApplyDelegationTaskDetailsUpdateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ApplyDelegationTaskDetailsUpdateResponse {
    return new ApplyDelegationTaskDetailsUpdateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ApplyDelegationTaskDetailsUpdateResponse {
    return new ApplyDelegationTaskDetailsUpdateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ApplyDelegationTaskDetailsUpdateResponse | PlainMessage<ApplyDelegationTaskDetailsUpdateResponse> | undefined, b: ApplyDelegationTaskDetailsUpdateResponse | PlainMessage<ApplyDelegationTaskDetailsUpdateResponse> | undefined): boolean {
    return proto3.util.equals(ApplyDelegationTaskDetailsUpdateResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetDelegationTaskRequest
 */
export class GetDelegationTaskRequest extends Message<GetDelegationTaskRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: bool markAsRead = 2;
   */
  markAsRead = false;

  constructor(data?: PartialMessage<GetDelegationTaskRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetDelegationTaskRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "markAsRead", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDelegationTaskRequest {
    return new GetDelegationTaskRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDelegationTaskRequest {
    return new GetDelegationTaskRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDelegationTaskRequest {
    return new GetDelegationTaskRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetDelegationTaskRequest | PlainMessage<GetDelegationTaskRequest> | undefined, b: GetDelegationTaskRequest | PlainMessage<GetDelegationTaskRequest> | undefined): boolean {
    return proto3.util.equals(GetDelegationTaskRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetDelegationTaskResponse
 */
export class GetDelegationTaskResponse extends Message<GetDelegationTaskResponse> {
  /**
   * @generated from field: protogen.DelegationTask delegationTask = 1;
   */
  delegationTask?: DelegationTask;

  /**
   * @generated from field: protogen.Family familyInfo = 2;
   */
  familyInfo?: Family;

  constructor(data?: PartialMessage<GetDelegationTaskResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetDelegationTaskResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "delegationTask", kind: "message", T: DelegationTask },
    { no: 2, name: "familyInfo", kind: "message", T: Family },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDelegationTaskResponse {
    return new GetDelegationTaskResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDelegationTaskResponse {
    return new GetDelegationTaskResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDelegationTaskResponse {
    return new GetDelegationTaskResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetDelegationTaskResponse | PlainMessage<GetDelegationTaskResponse> | undefined, b: GetDelegationTaskResponse | PlainMessage<GetDelegationTaskResponse> | undefined): boolean {
    return proto3.util.equals(GetDelegationTaskResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetMemberDelegationTaskRequest
 */
export class GetMemberDelegationTaskRequest extends Message<GetMemberDelegationTaskRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  constructor(data?: PartialMessage<GetMemberDelegationTaskRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetMemberDelegationTaskRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMemberDelegationTaskRequest {
    return new GetMemberDelegationTaskRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMemberDelegationTaskRequest {
    return new GetMemberDelegationTaskRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMemberDelegationTaskRequest {
    return new GetMemberDelegationTaskRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetMemberDelegationTaskRequest | PlainMessage<GetMemberDelegationTaskRequest> | undefined, b: GetMemberDelegationTaskRequest | PlainMessage<GetMemberDelegationTaskRequest> | undefined): boolean {
    return proto3.util.equals(GetMemberDelegationTaskRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetMemberDelegationTaskResponse
 */
export class GetMemberDelegationTaskResponse extends Message<GetMemberDelegationTaskResponse> {
  /**
   * @generated from field: protogen.DelegationTask delegationTask = 1;
   */
  delegationTask?: DelegationTask;

  /**
   * @generated from field: protogen.Family familyInfo = 2;
   */
  familyInfo?: Family;

  constructor(data?: PartialMessage<GetMemberDelegationTaskResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetMemberDelegationTaskResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "delegationTask", kind: "message", T: DelegationTask },
    { no: 2, name: "familyInfo", kind: "message", T: Family },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMemberDelegationTaskResponse {
    return new GetMemberDelegationTaskResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMemberDelegationTaskResponse {
    return new GetMemberDelegationTaskResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMemberDelegationTaskResponse {
    return new GetMemberDelegationTaskResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetMemberDelegationTaskResponse | PlainMessage<GetMemberDelegationTaskResponse> | undefined, b: GetMemberDelegationTaskResponse | PlainMessage<GetMemberDelegationTaskResponse> | undefined): boolean {
    return proto3.util.equals(GetMemberDelegationTaskResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateMemberDelegationTaskRequest
 */
export class UpdateMemberDelegationTaskRequest extends Message<UpdateMemberDelegationTaskRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string status = 2;
   */
  status = "";

  /**
   * @generated from field: string commentContent = 3;
   */
  commentContent = "";

  /**
   * @generated from field: repeated protogen.UploadAttachment attachments = 4;
   */
  attachments: UploadAttachment[] = [];

  /**
   * @generated from field: string recipientType = 5;
   */
  recipientType = "";

  /**
   * @generated from field: string commentContentHtml = 6;
   */
  commentContentHtml = "";

  constructor(data?: PartialMessage<UpdateMemberDelegationTaskRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateMemberDelegationTaskRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "commentContent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attachments", kind: "message", T: UploadAttachment, repeated: true },
    { no: 5, name: "recipientType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "commentContentHtml", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateMemberDelegationTaskRequest {
    return new UpdateMemberDelegationTaskRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateMemberDelegationTaskRequest {
    return new UpdateMemberDelegationTaskRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateMemberDelegationTaskRequest {
    return new UpdateMemberDelegationTaskRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateMemberDelegationTaskRequest | PlainMessage<UpdateMemberDelegationTaskRequest> | undefined, b: UpdateMemberDelegationTaskRequest | PlainMessage<UpdateMemberDelegationTaskRequest> | undefined): boolean {
    return proto3.util.equals(UpdateMemberDelegationTaskRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateMemberDelegationTaskResponse
 */
export class UpdateMemberDelegationTaskResponse extends Message<UpdateMemberDelegationTaskResponse> {
  /**
   * @generated from field: protogen.DelegationTask delegationTask = 1;
   */
  delegationTask?: DelegationTask;

  constructor(data?: PartialMessage<UpdateMemberDelegationTaskResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateMemberDelegationTaskResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "delegationTask", kind: "message", T: DelegationTask },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateMemberDelegationTaskResponse {
    return new UpdateMemberDelegationTaskResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateMemberDelegationTaskResponse {
    return new UpdateMemberDelegationTaskResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateMemberDelegationTaskResponse {
    return new UpdateMemberDelegationTaskResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateMemberDelegationTaskResponse | PlainMessage<UpdateMemberDelegationTaskResponse> | undefined, b: UpdateMemberDelegationTaskResponse | PlainMessage<UpdateMemberDelegationTaskResponse> | undefined): boolean {
    return proto3.util.equals(UpdateMemberDelegationTaskResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListMemberDelegationTasksRequest
 */
export class ListMemberDelegationTasksRequest extends Message<ListMemberDelegationTasksRequest> {
  /**
   * @generated from field: repeated string statuses = 1;
   */
  statuses: string[] = [];

  constructor(data?: PartialMessage<ListMemberDelegationTasksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListMemberDelegationTasksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "statuses", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMemberDelegationTasksRequest {
    return new ListMemberDelegationTasksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMemberDelegationTasksRequest {
    return new ListMemberDelegationTasksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMemberDelegationTasksRequest {
    return new ListMemberDelegationTasksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListMemberDelegationTasksRequest | PlainMessage<ListMemberDelegationTasksRequest> | undefined, b: ListMemberDelegationTasksRequest | PlainMessage<ListMemberDelegationTasksRequest> | undefined): boolean {
    return proto3.util.equals(ListMemberDelegationTasksRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListMemberDelegationTasksResponse
 */
export class ListMemberDelegationTasksResponse extends Message<ListMemberDelegationTasksResponse> {
  /**
   * @generated from field: repeated protogen.DelegationTask delegationTasks = 1;
   */
  delegationTasks: DelegationTask[] = [];

  constructor(data?: PartialMessage<ListMemberDelegationTasksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListMemberDelegationTasksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "delegationTasks", kind: "message", T: DelegationTask, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMemberDelegationTasksResponse {
    return new ListMemberDelegationTasksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMemberDelegationTasksResponse {
    return new ListMemberDelegationTasksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMemberDelegationTasksResponse {
    return new ListMemberDelegationTasksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListMemberDelegationTasksResponse | PlainMessage<ListMemberDelegationTasksResponse> | undefined, b: ListMemberDelegationTasksResponse | PlainMessage<ListMemberDelegationTasksResponse> | undefined): boolean {
    return proto3.util.equals(ListMemberDelegationTasksResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateDelegationTaskCommentRequest
 */
export class UpdateDelegationTaskCommentRequest extends Message<UpdateDelegationTaskCommentRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string content = 2;
   */
  content = "";

  /**
   * @generated from field: repeated protogen.UploadAttachment attachments = 3;
   */
  attachments: UploadAttachment[] = [];

  /**
   * @generated from field: string textContent = 4;
   */
  textContent = "";

  constructor(data?: PartialMessage<UpdateDelegationTaskCommentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateDelegationTaskCommentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "attachments", kind: "message", T: UploadAttachment, repeated: true },
    { no: 4, name: "textContent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateDelegationTaskCommentRequest {
    return new UpdateDelegationTaskCommentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateDelegationTaskCommentRequest {
    return new UpdateDelegationTaskCommentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateDelegationTaskCommentRequest {
    return new UpdateDelegationTaskCommentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateDelegationTaskCommentRequest | PlainMessage<UpdateDelegationTaskCommentRequest> | undefined, b: UpdateDelegationTaskCommentRequest | PlainMessage<UpdateDelegationTaskCommentRequest> | undefined): boolean {
    return proto3.util.equals(UpdateDelegationTaskCommentRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateDelegationTaskCommentResponse
 */
export class UpdateDelegationTaskCommentResponse extends Message<UpdateDelegationTaskCommentResponse> {
  /**
   * @generated from field: protogen.DelegationTask delegationTask = 1;
   */
  delegationTask?: DelegationTask;

  constructor(data?: PartialMessage<UpdateDelegationTaskCommentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateDelegationTaskCommentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "delegationTask", kind: "message", T: DelegationTask },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateDelegationTaskCommentResponse {
    return new UpdateDelegationTaskCommentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateDelegationTaskCommentResponse {
    return new UpdateDelegationTaskCommentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateDelegationTaskCommentResponse {
    return new UpdateDelegationTaskCommentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateDelegationTaskCommentResponse | PlainMessage<UpdateDelegationTaskCommentResponse> | undefined, b: UpdateDelegationTaskCommentResponse | PlainMessage<UpdateDelegationTaskCommentResponse> | undefined): boolean {
    return proto3.util.equals(UpdateDelegationTaskCommentResponse, a, b);
  }
}

/**
 * @generated from message protogen.DeleteDelegationTaskCommentRequest
 */
export class DeleteDelegationTaskCommentRequest extends Message<DeleteDelegationTaskCommentRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  constructor(data?: PartialMessage<DeleteDelegationTaskCommentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.DeleteDelegationTaskCommentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteDelegationTaskCommentRequest {
    return new DeleteDelegationTaskCommentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteDelegationTaskCommentRequest {
    return new DeleteDelegationTaskCommentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteDelegationTaskCommentRequest {
    return new DeleteDelegationTaskCommentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteDelegationTaskCommentRequest | PlainMessage<DeleteDelegationTaskCommentRequest> | undefined, b: DeleteDelegationTaskCommentRequest | PlainMessage<DeleteDelegationTaskCommentRequest> | undefined): boolean {
    return proto3.util.equals(DeleteDelegationTaskCommentRequest, a, b);
  }
}

/**
 * @generated from message protogen.DeleteDelegationTaskCommentResponse
 */
export class DeleteDelegationTaskCommentResponse extends Message<DeleteDelegationTaskCommentResponse> {
  /**
   * @generated from field: protogen.DelegationTask delegationTask = 1;
   */
  delegationTask?: DelegationTask;

  constructor(data?: PartialMessage<DeleteDelegationTaskCommentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.DeleteDelegationTaskCommentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "delegationTask", kind: "message", T: DelegationTask },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteDelegationTaskCommentResponse {
    return new DeleteDelegationTaskCommentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteDelegationTaskCommentResponse {
    return new DeleteDelegationTaskCommentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteDelegationTaskCommentResponse {
    return new DeleteDelegationTaskCommentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteDelegationTaskCommentResponse | PlainMessage<DeleteDelegationTaskCommentResponse> | undefined, b: DeleteDelegationTaskCommentResponse | PlainMessage<DeleteDelegationTaskCommentResponse> | undefined): boolean {
    return proto3.util.equals(DeleteDelegationTaskCommentResponse, a, b);
  }
}

